import * as React from 'react';

function CloudWithCheckmarkIconComponent(props: any) {
  return (
    <svg
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.006 7.11667L12.1393 7.98333L12.4393 8.02C13.5193 8.15667 14.336 9.07667 14.336 10.1667C14.336 11.36 13.3627 12.3333 12.1693 12.3333H4.33268C2.86268 12.3333 1.66602 11.1367 1.66602 9.66667C1.66602 8.19667 2.86268 7 4.33268 7H4.99935V6.5C4.99935 4.57 6.56935 3 8.49935 3C10.066 3 11.3893 4.03667 11.836 5.45667L7.99935 9.29333L6.51935 7.81333L5.81268 8.52L7.40935 10.1167C7.57268 10.28 7.78602 10.36 7.99935 10.36C8.21268 10.36 8.42602 10.28 8.58935 10.1167L13.8527 4.85333L13.146 4.14667L12.6094 4.68333C11.9094 3.10667 10.3327 2 8.49935 2C6.18268 2 4.26935 3.76 4.02602 6.01333C2.14602 6.17 0.666016 7.75 0.666016 9.66667C0.666016 11.69 2.30935 13.3333 4.33268 13.3333H12.166C13.9127 13.3333 15.3327 11.9133 15.3327 10.1667C15.3327 8.72667 14.3593 7.48667 13.006 7.11667Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default CloudWithCheckmarkIconComponent;
